import { Trans } from "@lingui/macro";
import { UiBox, UiModuleLoader } from "@smp/ui";

import { Screen } from "@/components/layout/screen";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";

import { useContextStickers } from "../../context";
import {
  ColorTagSelector,
  CommonTagSelector,
  ResetFilters,
} from "./components";

export const Filters = () => {
  const {
    actions: { setSelectedTags },
  } = useContextStickers();

  const {
    data: { grouped: tagGroups },
    isLoading: isTagGroupsLoading,
  } = useQueryPolotnoTagsAll();

  if (isTagGroupsLoading) {
    return <UiModuleLoader />;
  }

  return (
    <Screen
      title={<Trans>Filters</Trans>}
      actionsRight={<ResetFilters onChange={() => setSelectedTags([])} />}
    >
      <UiBox mb={4}>
        <CommonTagSelector group={tagGroups?.get("sticker_type")} />
      </UiBox>

      <UiBox mb={4}>
        <ColorTagSelector group={tagGroups?.get("color")} />
      </UiBox>

      <UiBox mb={4}>
        <CommonTagSelector group={tagGroups?.get("actual")} />
      </UiBox>
    </Screen>
  );
};
